module.exports = __webpack_public_path__ + "static/media/b-sci-major-36_LR.5fbfca63.jpg";